import { get } from "lodash"

export const getIsSuperuser = state => get(state, "user.isSuperuser")
export const getRawSelectedBase = state => get(state, "modules.portfolioRoot.selectedBase")
export const getSearchValue = state => get(state, "modules.portfolioRoot.searchValue")
export const getBaseDropdownVisible = state => get(state, "modules.portfolioRoot.baseDropdownVisible")
export const getModifiedScreens = state => get(state, "modules.portfolioRoot.modifiedScreens")
export const getSecurity = state => get(state, "modules.portfolioRoot.security")
export const getFactorId = state => get(state, "modules.portfolioRoot.factorId")
export const getTagCategories = (state) => get(state, "global.data.tagCategories.data.portfolio.tagCategories")
export const getAttributeCategories = (state) => get(state, "global.data.attributeCategories.data.portfolio.positionAttributeCategories")
export const getAssetType = () => "PORTFOLIO"
